import { Fragment } from 'react'
import { NextPage } from 'next'
import { useTranslation } from 'next-i18next'

import { DefaultLayout } from '~/shared/layouts/DefaultLayout'
import { usePageTitle } from '~/utils/tags'
import Metatags from '~/components/Metadata/Metatags'
import { getStaticPropsWrapper } from '~/utils/pageWrapper/staticPageWrapper'
import { DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES } from '~/shared/layouts/constants'
import { GetProps } from '~/utils/pageWrapper/types'
import Information from '~/tutor-on-demand/pages/TutorOnDemand/Information.page'

const TutorOnDemandIndexPage: NextPage = () => {
  const { t } = useTranslation('tutorOnDemand')
  const title = t('landingPage.title')
  return (
    <Fragment>
      <Metatags
        keywords={t('landingPage.keywords')}
        metaDescription={t('landingPage.metaDescription')}
        ogTitle={title}
        title={usePageTitle(title)}
      />

      <DefaultLayout zeroPadding>
        <Information />
      </DefaultLayout>
    </Fragment>
  )
}

export const getProps: GetProps = () => () => {
  return {
    props: {
      namespaces: [...DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES, 'tutorOnDemand', 'landing'],
    },
  }
}

export const getStaticProps = getStaticPropsWrapper(getProps)

export default TutorOnDemandIndexPage
